"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _urlHelper = _interopRequireDefault(require("./url-helper"));

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _datasourceHelper = _interopRequireDefault(require("./datasource/datasource-helper"));

var _merge = _interopRequireDefault(require("lodash/merge"));

var dataResultCache = {};

var DataProxyHelper =
/*#__PURE__*/
function () {
  function DataProxyHelper() {
    (0, _classCallCheck2["default"])(this, DataProxyHelper);
    this.dataProxyRequestBodies = {};
  }

  (0, _createClass2["default"])(DataProxyHelper, null, [{
    key: "getDataproxyFetchFunction",
    value: function () {
      var _getDataproxyFetchFunction = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(settings) {
        var baseUrl,
            url,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                baseUrl = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                url = baseUrl || _urlHelper["default"].getDataProxyUrl();
                return _context.abrupt("return", (0, _isomorphicFetch["default"])(url, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(settings)
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getDataproxyFetchFunction(_x) {
        return _getDataproxyFetchFunction.apply(this, arguments);
      }

      return getDataproxyFetchFunction;
    }()
  }, {
    key: "getCrawlerFetchFunction",
    value: function () {
      var _getCrawlerFetchFunction = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(value) {
        var reApiUrl, searchUrl;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reApiUrl = function reApiUrl(path, param) {
                  return _urlHelper["default"].getUrl(_urlHelper["default"].siteNames.RE_API, "/v1.0/".concat(path), null, param);
                };

                searchUrl = function searchUrl(path, param) {
                  return reApiUrl("onboarding/facebook/".concat(path), param);
                };

                return _context2.abrupt("return", (0, _isomorphicFetch["default"])(searchUrl('lookup', {
                  q: value,
                  lang: window.navigator.userLanguage || window.navigator.language
                }), {
                  credentials: 'include'
                }));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getCrawlerFetchFunction(_x2) {
        return _getCrawlerFetchFunction.apply(this, arguments);
      }

      return getCrawlerFetchFunction;
    }()
  }, {
    key: "getDataRequestBody",
    value: function () {
      var _getDataRequestBody = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(requestName, extraParameters) {
        var apiUrl,
            parameters,
            requestUrl,
            base,
            reApiUrl,
            searchUrl,
            request,
            result,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apiUrl = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : '';

                if (!(DataProxyHelper[requestName] && !extraParameters)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", DataProxyHelper[requestName]);

              case 3:
                parameters = (0, _merge["default"])(extraParameters, {
                  name: requestName
                });
                requestUrl = '';

                if (apiUrl) {
                  base = "".concat(apiUrl, "/v1.0/data/generaterequest");
                  requestUrl = parameters ? "".concat(base, "?").concat(_urlHelper["default"].param(parameters)) : base;
                } else {
                  reApiUrl = function reApiUrl(path, param) {
                    return _urlHelper["default"].getUrl(_urlHelper["default"].siteNames.RE_API, "/v1.0/".concat(path), null, param);
                  };

                  searchUrl = function searchUrl(param) {
                    return reApiUrl("data/generaterequest", param);
                  };

                  requestUrl = searchUrl(parameters);
                }

                _context3.next = 8;
                return (0, _isomorphicFetch["default"])(requestUrl, {
                  credentials: 'include'
                });

              case 8:
                request = _context3.sent;
                result = request.json();
                DataProxyHelper[requestName] = result;
                return _context3.abrupt("return", result);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getDataRequestBody(_x3, _x4) {
        return _getDataRequestBody.apply(this, arguments);
      }

      return getDataRequestBody;
    }()
  }, {
    key: "getDataFromParameters",
    value: function () {
      var _getDataFromParameters = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(value, dataType, encryptedBlob, baseUrl, reApiUrl) {
        var dataSource, result, requestBody, parameters, settings, data;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dataSource = _datasourceHelper["default"].getDataSource(dataType);
                _context4.prev = 1;

                if (!(dataType === 'facebookSearch')) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 5;
                return DataProxyHelper.getCrawlerFetchFunction(value);

              case 5:
                result = _context4.sent;
                _context4.next = 19;
                break;

              case 8:
                parameters = dataSource.getRequestParameters && dataSource.getRequestParameters(value);
                _context4.t0 = encryptedBlob;

                if (_context4.t0) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 13;
                return DataProxyHelper.getDataRequestBody(dataSource.getRequestName(value), parameters, reApiUrl);

              case 13:
                _context4.t0 = _context4.sent;

              case 14:
                requestBody = _context4.t0;
                settings = dataSource.getDataPromise(value, requestBody);
                _context4.next = 18;
                return DataProxyHelper.getDataproxyFetchFunction(settings, baseUrl);

              case 18:
                result = _context4.sent;

              case 19:
                _context4.next = 21;
                return result.json();

              case 21:
                data = _context4.sent;
                return _context4.abrupt("return", {
                  data: dataSource.mapResult(data),
                  requestBody: requestBody
                });

              case 25:
                _context4.prev = 25;
                _context4.t1 = _context4["catch"](1);
                console.log(_context4.t1);
                return _context4.abrupt("return", []);

              case 29:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[1, 25]]);
      }));

      function getDataFromParameters(_x5, _x6, _x7, _x8, _x9) {
        return _getDataFromParameters.apply(this, arguments);
      }

      return getDataFromParameters;
    }()
  }, {
    key: "getData",
    value: function getData(value, dataType, dataPath, callback) {
      var encryptedBlob = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var baseUrl = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var apiUrl = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
      var newCallback = callback;

      if (dataPath) {
        newCallback = function newCallback(dataResult, requestBody) {
          var dataSource = _datasourceHelper["default"].getDataSource(dataType);

          var menu = dataSource.resolvePath(dataResult, dataPath);

          if (menu) {
            callback(menu, requestBody);
          }
        };
      }

      if (value) {
        var cacheKey = "".concat(value, ".").concat(dataType);
        var dataResult = dataResultCache[cacheKey];

        if (dataResult) {
          if (dataResult.hasOwnProperty('data')) {
            newCallback(dataResult.data, dataResult.requestBody);
          } else {
            dataResult.pendingCallBacks.push(newCallback);
          }
        } else {
          // create the data call
          dataResult = {
            pendingCallBacks: [newCallback]
          };
          DataProxyHelper.getDataFromParameters(value, dataType, encryptedBlob, baseUrl, apiUrl).then(function (result) {
            dataResult.data = result.data;
            dataResult.requestBody = result.requestBody;
            dataResult.pendingCallBacks.forEach(function (func) {
              try {
                func(result.data, result.requestBody);
              } catch (ex) {
                console.error(ex);
              }
            });
            dataResult.pendingCallBacks = [];
          })["catch"](function (i) {
            dataResult.data = null;
            dataResult.pendingCallBacks = [];
          });
          dataResultCache[cacheKey] = dataResult;
        }
      }
    }
  }, {
    key: "convertInputToDataSourceValue",
    value: function convertInputToDataSourceValue(value, dataType) {
      var dataSource = _datasourceHelper["default"].getDataSource(dataType);

      if (dataSource && dataSource.convertFunction) {
        return dataSource.convertFunction(value);
      }

      return value;
    }
  }, {
    key: "getDataProxyUrl",
    value: function getDataProxyUrl() {
      return _urlHelper["default"].getDataProxyUrl();
    }
  }]);
  return DataProxyHelper;
}();

var _default = DataProxyHelper;
exports["default"] = _default;